import { render, staticRenderFns } from "./page-terms.vue?vue&type=template&id=847a065a&scoped=true"
import script from "./page-terms.vue?vue&type=script&lang=js"
export * from "./page-terms.vue?vue&type=script&lang=js"
import style0 from "./page-terms.vue?vue&type=style&index=0&id=847a065a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847a065a",
  null
  
)

export default component.exports